const SETTING_DETAIL_LOADING = 'SETTING_DETAIL_LOADING';
const SETTING_DETAIL_SUCCESS = 'SETTING_DETAIL_SUCCESS';
const SETTING_DETAIL_FAILURE = 'SETTING_DETAIL_FAILURE';

export const settingDetailActions = {
  SETTING_DETAIL_LOADING,
  SETTING_DETAIL_SUCCESS,
  SETTING_DETAIL_FAILURE,
};
